import script from "./AppointmentDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./AppointmentDetails.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__